import React from 'react';

const AboutSection = () => {
  return (
    <section className="about-section" id="about">
      <div className="container">
        <h2 className="section-title-aboutSection">Sobre o museu</h2>
        <div className="about-content">
          <p>
            Em 1985 a Congregação da Faculdade de Medicina de Ribeirão Preto, designou um grupo de professores,
            liderados por Ruy Ferreira Santos e pelo aluno Osvaldo Cardoso de Santana Filho, para cuidar da memória
            institucional. Na ocasião, este grupo recuperou um conjunto de documentos produzidos nas décadas iniciais
            da Instituição, os quais permaneceram por longo tempo num depósito, a despeito dos esforços envidados pela
            Comissão no sentido de abrigá-los num espaço físico adequado que fosse o embrião de um museu institucional.
          </p>
          <p>
            Em 1997, quando o Centro Acadêmico Rocha Lima passou a ocupar o Centro de Vivência, o espaço que ocupava
            foi liberado e destinado à guarda do acervo. Este espaço passou a ser denominado Museu Histórico. Com o
            tempo, o acervo cresceu graças a doações mas, sobretudo, em consequência de uma busca ativa em depósitos
            de onde, não fora este esforço, sairiam para o descarte.
          </p>
          <p>
            Em 1999, a tarefa de zelar pelo museu passou a ser atribuição da então recém-criada Comissão de Cultura e
            Extensão Universitária. Em 2008, o Museu foi transferido para o prédio do Espaço Cultural e de Extensão
            Universitária (ECEU), portanto, fora do Campus. Em 2017 o Conselho Técnico-Administrativo da FMRP aprovou o
            Regimento do Museu, já então denominado Centro de Memória e Museu Histórico (CMMH) que passou a ser
            coordenado por um Conselho Deliberativo.
          </p>
        </div>
        <div className="stats-container">
          <div className="stat-item">
            <div className="stat-number">10.000+</div>
            <div className="stat-label">Itens de Acervo</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">35+</div>
            <div className="stat-label">Anos de História</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
